import { getMissingFirebaseEnvKeys, renderFirebaseConfigErrorHtml } from './lib/firebaseEnv';
import './styles/globals.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

const missingFirebaseEnv = getMissingFirebaseEnvKeys();

if (missingFirebaseEnv.length > 0) {
  root.innerHTML = renderFirebaseConfigErrorHtml(missingFirebaseEnv);
} else {
  void import('./bootstrap').then(({ bootstrapApp }) => bootstrapApp(root));
}
